import { Injectable, Optional, Inject } from '@angular/core';
import { GenericTranslationService } from '../../services/generic-translation.service';
import {
  ComponentConfig,
  createComponentConfigToken,
  createConfigProvider,
} from '../../services/translation-config.helper';
import { GenericInlineItemListTranslations, GenericInlineItemListTranslationInput } from './generic-inline-item-list-translations.interface';
import { DEFAULT_GENERIC_INLINE_ITEM_LIST_TRANSLATIONS } from './generic-inline-item-list-translations.defaults';
import { GERMAN_GENERIC_INLINE_ITEM_LIST_TRANSLATIONS } from './generic-inline-item-list-translations.de';

export interface GenericInlineItemListConfig extends ComponentConfig<GenericInlineItemListTranslations> {}

export const GENERIC_INLINE_ITEM_LIST_CONFIG = createComponentConfigToken<GenericInlineItemListTranslations>('GENERIC_INLINE_ITEM_LIST_CONFIG');

@Injectable({
  providedIn: 'root',
})
export class GenericInlineItemListTranslationService extends GenericTranslationService<GenericInlineItemListTranslations> {
  constructor(@Optional() @Inject(GENERIC_INLINE_ITEM_LIST_CONFIG) config?: GenericInlineItemListConfig) {
    super(DEFAULT_GENERIC_INLINE_ITEM_LIST_TRANSLATIONS);

    this.registerLanguage('de', GERMAN_GENERIC_INLINE_ITEM_LIST_TRANSLATIONS);

    if (config?.translations) {
      this.setGlobalTranslations(config.translations);
    }
  }
}

export const GenericInlineItemListConfigProvider = createConfigProvider<GenericInlineItemListTranslations>(GENERIC_INLINE_ITEM_LIST_CONFIG);
